import React from "react";

import { shortenNumber }     from "_common/utils";
import EditUserProfileDialog from "_components/organisms/editUserProfile";
import FollowInfoBox         from "_components/organisms/followInfoBox";
import useStyles             from "_styles/templates/userProfileHeader";

import ProfileDetails from "./components/profileDetails";
import ProfileUGCMenu from "./components/profileUgcMenu";

const component = props => {
	const {
		anchorEl,
		editUserProfile,
		followerCount,
		followInfoDialog,
		getDonationSrc, // own profile
		getSrc, // share other profile
		handleClick,
		handleClickAway, // share
		handleClickOpen, // share
		handleClose,
		toggleEditUserProfile,
		isModerator,
		toggleErrorModal,
		toggleModeratorOption,
		handleRedirect,
		isFollowingUser,
		isOwnProfile,
		shareModalOpen, // share
		shareAnchorEl, // share
		toggleDialogInfoBox,
		userBroadcasterDetails,
		userId,
		userProfile,
		isLoggedIn
	} = props;

	const { classes } = useStyles ( { isOwnProfile } );

	let listeningHours = 0, broadcastingHours = 0;

	if ( userBroadcasterDetails ) {
		const { totalListeningMinutes, totalBroadcastingMinutes } = userBroadcasterDetails;

		if ( totalListeningMinutes && totalListeningMinutes < 60 )
			listeningHours = ( totalListeningMinutes / 60 ).toFixed ( 2 );
		else
			listeningHours = shortenNumber ( Math.floor ( totalListeningMinutes / 60 ) );

		if ( totalBroadcastingMinutes && totalBroadcastingMinutes < 60 )
			broadcastingHours = ( totalBroadcastingMinutes / 60 ).toFixed ( 2 );
		else
			broadcastingHours = shortenNumber ( Math.floor ( totalBroadcastingMinutes / 60 ) );
	}

	return (
		<div className = { classes.profileHeaderWrapper }>
			<div className = { classes.profileHeaderMiddle }>
				<ProfileDetails
					followerCount         = { followerCount }
					getDonationSrc        = { getDonationSrc }
					getSrc                = { getSrc }
					handleClick           = { handleClick }
					handleClickAway       = { handleClickAway }
					handleClickOpen       = { handleClickOpen }
					handleRedirect        = { handleRedirect }
					isFollowingUser       = { isFollowingUser }
					isLoggedIn            = { isLoggedIn }
					isModerator           = { isModerator }
					isOwnProfile          = { isOwnProfile }
					shareAnchorEl         = { shareAnchorEl }
					shareModalOpen        = { shareModalOpen }
					toggleDialogInfoBox   = { toggleDialogInfoBox }
					toggleErrorModal      = { toggleErrorModal }
					toggleModeratorOption = { toggleModeratorOption }
					userId                = { userId }
					userProfile           = { userProfile }
				/>

			</div>

			<EditUserProfileDialog
				editUserProfile       = { editUserProfile }
				toggleEditUserProfile = { toggleEditUserProfile }
			/>

			<FollowInfoBox
				activeType          = { followInfoDialog.activeType }
				followers           = { followerCount }
				following           = { userProfile?.follow?.following }
				open                = { followInfoDialog.status }
				toggleDialogInfoBox = { toggleDialogInfoBox }
				userId              = { userProfile.id }
			/>

			<ProfileUGCMenu
				anchorEl            = { anchorEl }
				broadcastingHours   = { broadcastingHours }
				followerCount       = { followerCount }
				followingCount      = { userProfile?.follow?.following }
				handleClose         = { handleClose }
				listeningHours      = { listeningHours }
				toggleDialogInfoBox = { toggleDialogInfoBox }
			/>
		</div>
	);
};

export default component;
